import { render } from "./ViewReport.vue?vue&type=template&id=72fd5d28&scoped=true"
import script from "./ViewReport.vue?vue&type=script&lang=js"
export * from "./ViewReport.vue?vue&type=script&lang=js"

import "./ViewReport.vue?vue&type=style&index=0&id=72fd5d28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fd5d28"]])

export default __exports__